import React, { useState } from 'react';
import { NavItem } from '../types';
import { Menu, X } from 'lucide-react';

const navItems: NavItem[] = [
  { label: 'GALLERY', href: '#gallery' },
  { label: 'EXHIBITIONS', href: '#exhibitions' },
  { label: 'ABOUT', href: '#about' },
  { label: 'CONTACT', href: '#contact' },
];

export const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setIsMenuOpen(false);
    
    // If it's a top link
    if (href === '#') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    // Find element and scroll
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 w-full flex justify-between items-center px-8 md:px-12 py-8 z-50 transition-all duration-300 ${isMenuOpen ? 'bg-transparent' : 'bg-background/80 backdrop-blur-sm'}`}>
        <a 
          href="#" 
          onClick={(e) => handleScroll(e, '#')}
          className="text-xl font-serif tracking-wider font-semibold text-text cursor-pointer hover:opacity-70 transition-opacity z-50"
        >
          DARDO
        </a>
        
        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-12">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => handleScroll(e, item.href)}
              className="text-[11px] font-sans font-medium tracking-widest text-text hover:text-accent transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </div>
        
        {/* Mobile Menu Icon */}
        <button 
          className="md:hidden z-50 text-text hover:opacity-70 transition-opacity"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`fixed inset-0 bg-[#F7F5F0] z-40 flex flex-col justify-center items-center transition-opacity duration-500 ease-in-out md:hidden ${isMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
        <div className="flex flex-col space-y-8 text-center">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => handleScroll(e, item.href)}
              className="text-2xl font-serif italic text-text hover:text-accent transition-colors duration-300"
            >
              {item.label.toLowerCase()}
            </a>
          ))}
        </div>
      </div>
    </>
  );
};